module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/event-4-3d26addf36e83ca54fea0de7b5ae10cb.jpg";